import { throwError } from 'rxjs';

export class PromiseLoad {
    readonly #url: string;

    constructor(url: string, tokenStorageName?: string | undefined) {
        this.#url = url;
    }

    public get<T>(): Promise<T> {
        return new Promise((resolve, reject) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            xhr.open('GET', this.#url, true);

            xhr.onload = (): void => {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(throwError('Error load config app'));
                }
            };

            xhr.onerror = (): void => {
                reject(throwError('Error load config app'));
            };

            xhr.send();
        });
    }
}
